import http from '@/api/http'

export default {
  /**
   * SMS 認証が必要かどうか
   */
  shouldSmsAuth(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/regist/', params)
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * 登録処理
   */
  signup(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      // token をクリアしないとログイン済みとサーバで判断されてしまい登録できない
      http.defaults.headers.common['TOKEN'] = ''

      http
        .post('/regist/', params)
        .then(res => {
          http.defaults.headers.common['TOKEN'] = res.data.token
          resolve(res.data)
        })
        .catch(reject)
    })
  },

  /**
   * ログイン処理
   */
  login(authInfo: any): Promise<any> {
    return new Promise((resolve, reject) => {
      // token が header がついていると新しい token が発行されないのでクリア
      http.defaults.headers.common['TOKEN'] = ''

      http
        .post('/login/', authInfo)
        .then(res => {
          if (res.data.token) {
            // token の上書き
            http.defaults.headers.common['TOKEN'] = res.data.token
          }
          resolve(res.data)
        })
        .catch(reject)
    })
  },

  /**
   * トークンの検証
   */
  verifyToken(token: string): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/token_valid/', { token: token })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * ログイン情報の取得
   */
  fetchAuthInfo(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/account_handover/', {
          page: 'get_init',
          ...params
        })
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * ポイント合算対象者かチェック
   */
  checkPointAddUp(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/point_add_up/', params)
        .then(res => resolve(res.data))
        .catch(reject)
    })
  },

  /**
   * ポイントの合算
   */
  addUpPoint(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      http
        .post('/point_add_up/', params)
        .then(res => resolve(res.data))
        .catch(reject)
    })
  }
}
